<template>
  <div class="wrapper">
    <hollow-dots-spinner
      :animation-duration="4000"
      :dot-size="30"
      :dots-num="5"
      color="#FFC733"
    />
  </div>
</template>
<script>
import { HollowDotsSpinner } from 'epic-spinners';

export default {
  name: 'Spinner',
  components: {
    HollowDotsSpinner
  }
};
</script>
<style scoped>
.wrapper {
  /* margin-top: 10em; */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue